// Version: 1.1 - Header component with official PNG logo
import React, { useState, useEffect } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <a href="#home" className="logo-link">
            <img 
              src={`${process.env.PUBLIC_URL}/headacheMDER_Official_Logo.png`}
              alt="headacheMD ER - Emergency Headache Care Concept"
              className="logo"
            />
          </a>

          <button 
            className="mobile-menu-btn"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
            <li><a href="#home" onClick={() => setIsMobileMenuOpen(false)}>Home</a></li>
            <li><a href="#about" onClick={() => setIsMobileMenuOpen(false)}>About</a></li>
            <li><a href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a></li>
            <li><a href="#when-to-visit" onClick={() => setIsMobileMenuOpen(false)}>When to Visit ER</a></li>
            <li><a href="#find-er" onClick={() => setIsMobileMenuOpen(false)}>Find an ER</a></li>
            <li>
              <a 
                href="https://www.headacheMD.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="return-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <i className="fa fa-home"></i> headacheMD.org
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
